module.exports = __webpack_public_path__ + "img/talk2mejr.bcbc4c58.png";